import { render, staticRenderFns } from "./LectureCategory.vue?vue&type=template&id=705508b0&"
import script from "./LectureCategory.vue?vue&type=script&lang=js&"
export * from "./LectureCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports